// config
import axios from 'axios';
// utils

const getTicketDetail = async ({ id }) => {
  const token = 'FgTJfl4Orng6YP3YGqBznJ5DjmgKis';
  const requestConfig = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };

  return await axios.get(
    `http://localhost:8000/v1/price-negotiation/tickets/${id}/`,
    requestConfig
  );
};

export default getTicketDetail;
